(function($, THERMOS, cssua){
	const map = THERMOS.va.pathname.split('/')[2];
	const FAVO_MAX = 50;
	const a = 'is-active';
	const v = 'is-visible';
	const h = 'is-hide';
	const slideSpeed = '300';
	let $chip = $('<span></span>', {
		addClass: 'recipe-favoChip',
		text: 'お気に入りの上限50件を超えています'
	});
	const arrowPath = 'M12,40.1c-1,0-2-.4-2.9-1.2-1.6-1.6-1.6-4.1,0-5.7l13.2-13.2L9.1,6.8c-1.6-1.6-1.6-4.1,0-5.7s4.1-1.6,5.7,0l16.1,16.1c1.6,1.6,1.6,4.1,0,5.7l-16.1,16.1c-.8.8-1.8,1.2-2.9,1.2h0Z';

	// [共通] お気に入りカウント／お気に入りページリンク表示
	const setFavoCount = () => {
		let favoriteStorage = [];
		for (let i in localStorage) {
			if (i.indexOf('thermosFavoriteRecipeList-') !== -1) { favoriteStorage.push(i); }
		}
		if ($('.recipe-favoFloat').length) {
			$('.__favoCount').text(favoriteStorage.length);
		} else {
			let favoFloat = '<a href="/recipe/favorite.html" class="recipe-favoFloat opacity"><span class="__text">お気に入り<br data-view="pc tablet">レシピ</span>' +
				`<svg aria-hidden="true"><use xlink:href="/common/svg/sprite.svg#favo_active" /></svg><span class="__favoCount">${favoriteStorage.length}</span></a>`;

			if (map === '' || map === 'index.html') {
				$('.mod-topicPath').after(favoFloat);
			} else if (map === 'detail') {
				$('.mod-head01').after(favoFloat);
			} else {
				$('.recipe-catIdx-h1').after(favoFloat);
			}
		}
	};
	setFavoCount();

	// [一覧共通] お気に入り処理
	const setFavoCatIdx = () => {
		$('.container').append($chip);

		$('.recipe-list-item').each((idx, ele) => {
			let thisID = $(ele).find('a').eq(0).attr('href').split('/')[3];
			if (thisID) { thisID = thisID.replace(/\.html/, ''); }
			let $add = $(ele).find('.icon-favo');
			let $del = $(ele).find('.icon-favo_active');

			// お気に入り商品かチェック
			let favoFlag;
			for (let item in localStorage) {
				if (item.indexOf('thermosFavoriteRecipeList-') !== -1) {
					if (item.replace(/thermosFavoriteRecipeList-/, '') === thisID) {
						favoFlag = true;
					}
				}
			}
			if (!favoFlag) {
				$add.addClass(a);
			} else {
				$del.addClass(a);
			}

			// お気に入り追加
			$add.on('click', () => {
				let favoStorage = [];
				for (let i in localStorage) {
					if (i.indexOf('thermosFavoriteRecipeList-') !== -1) {
						favoStorage.push(i);
					}
				}
				if (favoStorage.length >= FAVO_MAX) {
					// すでに50件登録がある場合はチップ表示
					if (THERMOS.va.window.width >= 1024) {
						$chip.css({ 'top': $add.offset().top + 40, 'left': $add.offset().left - 132 });
					}
					$chip.addClass(a);
					setTimeout(() => { $chip.addClass(v); });
					setTimeout(() => {
						$chip.removeClass(v);
						setTimeout(() => { $chip.removeClass(a); }, 100);
					}, 3000);
				} else {
					// なければ追加成功
					let favoDatetime = new Date();
					favoDatetime = `${favoDatetime.getFullYear()}/${('0' + (favoDatetime.getMonth() + 1)).slice(-2)}/${(('0' + (favoDatetime.getDate())).slice(-2))} ` +
						`${('0' + (favoDatetime.getHours())).slice(-2)}:${('0' + (favoDatetime.getMinutes())).slice(-2)}:${('0' + (favoDatetime.getSeconds())).slice(-2)}`;
					localStorage.setItem('thermosFavoriteRecipeList-' + thisID, favoDatetime);
					$add.removeClass(a);
					$del.addClass(a);
					setFavoCount();
				}
			});

			// 削除
			$del.on('click', () => {
				localStorage.removeItem('thermosFavoriteRecipeList-' + thisID);
				$del.removeClass(a);
				$add.addClass(a);
				setFavoCount();
			});

		});
	};
	if ($('.recipe-catIdx').length || $('.recipe-special').length) {
		setFavoCatIdx();
	}

	// [レシピTOP] MVカルーセル
	const topMainVis = () => {
		let splide_mv = new Splide('.recipe-top-mainVis.splide', {
			type: 'loop',
			arrows: true,
			arrowPath: arrowPath,
			pagination: true,
			paginationKeyboard: true,
			speed: 1500,
			autoplay: true,
			interval: 5000,
			pauseOnHover: false,
			autoWidth: true,
			gap: '20px',
			focus: 'center',
			breakpoints: {
				640: {
					gap: '10px',
				},
			}
		});
		splide_mv.mount();
		// 一時停止中にプログレスアニメーションを停止する
		document.querySelector('.recipe-top-mainVis.splide .splide__toggle').addEventListener('click', () => {
			document.querySelector('.recipe-top-mainVis.splide .splide__pagination').classList.toggle('is-paused');
		});
	};
	if (map === '' || map === 'index.html') {
		topMainVis();
	}

	// [シャトルシェフ・フライパン・スープジャー] 検索フォーム：検索時はアコーディオンOPEN、フォーム位置までスクロール
	const setRecipeSearchForm = () => {
		$('.recipe-search-head').on('click', (e) => {
			$(e.currentTarget).toggleClass(a);
			$(e.currentTarget).prev('.recipe-search-body').stop().slideToggle(slideSpeed);
			if (!$(e.currentTarget).hasClass(a)) {
				let pos = $('.recipe-search').offset().top;
				pos -= (THERMOS.va.window.width < THERMOS.va.device.sp) ? 60 : 90;
				$('html,body').stop().animate({ scrollTop: pos }, 1200, 'easeOutExpo');
			}
		});

		let searchFlg = false;
		$('.mod-check-input').each((idx, ele) => {
			if ($(ele).prop('checked')) {
				searchFlg = true;
			}
		});
		if ($('.recipe-search-inputKeyword').val()) {
			searchFlg = true;
		}
		if (searchFlg) {
			$('.recipe-search-head, .recipe-search-body').addClass(a);

			setTimeout(() => {
				let pos = $('.recipe-search-submit').offset().top;
				if (THERMOS.va.window.width < THERMOS.va.device.sp) {
					pos -= 60;
				} else {
					pos -= 90;
				}
				$('html,body').stop().animate({ scrollTop: pos }, 1200, 'easeOutExpo');
			}, 300);
		}
	};
	if ($('.recipe-search').length) {
		setRecipeSearchForm();
	}

	// [テーブルスープジャー] ランダムピックアップレシピ
	const replaceHTML = (_$box, _recipe) => {
		console.log(_recipe);
		_$box.find('.js-pickup-a').attr('data-label', 'fc-idx_'+ _recipe[0]);
		_$box.find('.js-pickup-a').attr('href', '/recipe/detail/'+ _recipe[1] +'.html');
		_$box.find('.js-pickup-name').text(_recipe[2]);
		_$box.find('.js-pickup-lead').html(_recipe[3]);
		_$box.find('.js-pickup-img').attr('src', './recipe_file/file/'+ _recipe[1] +'.jpg?_size=6');
	};
	const setRandomArr = (array, num) => {
		var arr = array;
		var t = [];
		var r = [];
		var l = arr.length;
		var n = num < l ? num : l;
		while(n-- > 0) {
			var i = Math.random() * l | 0;
			r[n] = t[i] || arr[i];
			--l;
			t[i] = t[l] || arr[l];
		}
		return r;
	};
	if (map === 'foodcontainer') {
		const script = document.createElement('script');
		script.type = 'text/javascript';
		script.src = '/recipe/foodcontainer/pickup_recipe.js';

		script.onload = () => {
			// recipeArrは /recipe/foodcontainer/pickup_recipe.jsにある
			const pickupArr = setRandomArr(recipesArr, 1);
			replaceHTML($('.js-pickup'), pickupArr[0]);
		};
		document.body.appendChild(script);
	}

	// [TEA & CAFE] タブ切り替え
	const countItem = (_cat) => {
		$('.js-count').text($('.recipe-list-item[data-key='+ _cat +']').length);
	};
	const showItem = (_cat) => {
		$('.recipe-list-item').each((idx, ele) => {
			if ($(ele).attr('data-key') === _cat) {
				$(ele).removeClass(h);
			} else {
				$(ele).addClass(h);
			}
		});
	};
	if (map === 'tea_cafe' || map === 'lunchbox_2000') {
		// 初期表示
		$('.recipe-list-item').addClass(h);
		showItem($('.recipe-tab-item.is-active').attr('data-switch'));
		countItem($('.recipe-tab-item.is-active').attr('data-switch'));

		$('.recipe-tab-item').on('click', (e) => {
			var cat = $(e.currentTarget).attr('data-switch');
			$('.recipe-tab').removeClass('okazu_main').removeClass('okazu_sub').addClass(cat);
			$('.recipe-tab-item').removeClass(a);
			$(e.currentTarget).addClass(a);
			showItem(cat);
			countItem(cat);
		});
	}

	// [レシピ詳細] お気に入り処理
	const setFavoDetail = () => {
		$('.container').append($chip);

		let thisID = THERMOS.va.pathname.split('/')[3].replace(/\.html/, '');
		let $add = $('.recipe-detail-buttons ._add');
		let $del = $('.recipe-detail-buttons ._delete');

		// お気に入り商品かチェック
		let favoFlag;
		for (let item in localStorage) {
			if (item.indexOf('thermosFavoriteRecipeList-') !== -1) {
				if (item.replace(/thermosFavoriteRecipeList-/, '') === thisID) {
					favoFlag = true;
				}
			}
		}
		if (!favoFlag) {
			$add.each((idx, ele) => { $(ele).addClass(a); });
		} else {
			$del.each((idx, ele) => { $(ele).addClass(a); });
		}

		$add.each((idx, ele) => {
			$(ele).on('click', () => {
				let favoStorage = [];
				for (let i in localStorage) {
					if (i.indexOf('thermosFavoriteRecipeList-') !== -1) {
						favoStorage.push(i);
					}
				}
				if (favoStorage.length >= FAVO_MAX) {
					// すでに50件登録がある場合はチップ表示
					if (THERMOS.va.window.width >= 1024) {
						if ($(ele).parents('.recipe-detail-buttons._bottom').length) {
							$chip.css({ 'top': $(ele).offset().top + 76, 'left': $(ele).offset().left + 10 });
						} else {
							$chip.css({ 'top': $(ele).offset().top + 76, 'left': $(ele).offset().left + 15 });
						}
					}
					$chip.addClass(a);
					setTimeout(() => { $chip.addClass(v); });
					setTimeout(() => {
						$chip.removeClass(v);
						setTimeout(() => { $chip.removeClass(a); }, 100);
					}, 3000);
				} else {
					// なければ追加成功
					let favoDatetime = new Date();
					favoDatetime = `${favoDatetime.getFullYear()}/${('0' + (favoDatetime.getMonth() + 1)).slice(-2)}/${(('0' + (favoDatetime.getDate())).slice(-2))} ` +
						`${('0' + (favoDatetime.getHours())).slice(-2)}:${('0' + (favoDatetime.getMinutes())).slice(-2)}:${('0' + (favoDatetime.getSeconds())).slice(-2)}`;
					localStorage.setItem('thermosFavoriteRecipeList-' + thisID, favoDatetime);
					$add.each((idx2, ele2) => { $(ele2).removeClass(a); });
					$del.each((idx2, ele2) => { $(ele2).addClass(a); });
					setFavoCount();
				}
			});
		});
		$del.each((idx, ele) => {
			$(ele).on('click', () => {
				localStorage.removeItem('thermosFavoriteRecipeList-' + thisID);
				$del.each((idx2, ele2) => { $(ele2).removeClass(a); });
				$add.each((idx2, ele2) => { $(ele2).addClass(a); });
				setFavoCount();
			});
		});
	};
	// [レシピ詳細] シェアアイコンURL設定
	const setShare = () => {
		let thisURL = location.href;
		let thisTEXT = $('title').text();

		let lineURL = $('.__widget._line').attr('href').replace(/{{url}}/, thisURL).replace(/{{text}}/, encodeURIComponent(thisTEXT));
		$('.__widget._line').attr('href', lineURL);
		let xURL = $('.__widget._x').attr('href').replace(/{{url}}/, thisURL).replace(/{{text}}/, encodeURIComponent(thisTEXT));
		$('.__widget._x').attr('href', xURL);
	};
	// [レシピ詳細] おすすめレシピ出力
	const setRecommendRecipe = () => {
		let thisID = THERMOS.va.pathname.split('/')[3].replace(/\.html/, '');
		let thisCat = document.querySelector('.rt_cf_r_category_id').textContent;
		let tagListStr = '';
		if (document.querySelectorAll('.recipe-detail-recommend .r_tags').length) {
			document.querySelectorAll('.recipe-detail-recommend .r_tags').forEach(ele => {
				tagListStr += ele.textContent + '/';
			});
			let jsonURL = `/ajax/recipe/recommend/${thisCat}/${thisID}.json`;

			fetch(jsonURL).then(response => response.json()).then(data => {
				if (data.rt_cf_recipe_list.length) {
					let recipeList = data.rt_cf_recipe_list;
					let filteredRecipeList = [];

					// 同じタグを持つレシピに絞る
					recipeList.forEach(ele => {
						ele.r_tags.find(tag => {
							if (tagListStr.indexOf(tag._key) !== -1) {
								filteredRecipeList.push(ele);
								return true;
							}
						});
					});

					// スープジャーレシピの場合… 冷たいレシピ：11月～2月 掲出なし／温かいレシピ：7月～8月 掲出なし
					if (thisCat === 'foodcontainer') {
						let foodcontainerFilteredList = [];
						const thisMonth = new Date().getMonth() + 1;
						if (thisMonth === 11 || thisMonth === 12 || thisMonth === 1 || thisMonth === 2) {
							filteredRecipeList.forEach(ele => {
								let flg = true;
								ele.r_tags.find(tag => {
									if (tag._key === 'foodcontainer-cold') {
										flg = false;
										return true;
									}
								});
								if (flg) {
									foodcontainerFilteredList.push(ele);
								}
							});
						} else if (thisMonth === 7 || thisMonth === 8) {
							filteredRecipeList.forEach(ele => {
								let flg = true;
								ele.r_tags.find(tag => {
									if (tag._key === 'foodcontainer-hot') {
										flg = false;
										return true;
									}
								});
								if (flg) {
									foodcontainerFilteredList.push(ele);
								}
							});
						}
						filteredRecipeList = foodcontainerFilteredList;
					}

					// ランダムで4件表示
					let count = 4;
					count = (filteredRecipeList.length < count) ? filteredRecipeList.length : count;
					if (count > 0) {
						let appendHTML = '';
						for (let i = 0; i < count; i++) {
							let r = Math.floor(Math.random() * (filteredRecipeList.length - i), (count - i)) + i;
							let idx = r - 1;

							appendHTML += `<li class="recipe-list-item"><a href="${filteredRecipeList[idx].rt_cf_r_recipe_href.href}"><figure class="recipe-list-item-img">`;
							if (filteredRecipeList[idx].rt_cf_r_new) {
								appendHTML += `<span class="mod-new">NEW</span>`;
							}
							appendHTML += `<img src="${filteredRecipeList[idx].rt_cf_r_image.src}" loading="lazy" width="290" height="193"></figure></a>` +
								`<div class="recipe-list-item-txt"><a href="${filteredRecipeList[idx].rt_cf_r_recipe_href.href}">` +
								`<p class="recipe-list-item-name">${filteredRecipeList[idx].rt_cf_r_name.content[0]}</p></a></div></li>`;

							filteredRecipeList.splice(r - 1, 1);
						}
						document.querySelector('.recipe-detail-recommend .recipe-list-body').innerHTML = appendHTML;
					} else {
						document.querySelector('.recipe-detail-recommend').remove();
					}
				} else {
					document.querySelector('.recipe-detail-recommend').remove();
				}
			});
		} else {
			document.querySelector('.recipe-detail-recommend').remove();
		}
	};
	// [レシピ詳細] JSON-LD出力
	const setJsonld = () => {
		let appendSrc =
			'{"@context": "http://schema.org/", "@type": "Recipe",' +
			`"name": "${$('.mod-head01-inner').text()}",` +
			`"image": "https://www.thermos.jp${$('.vr_image').attr('src').slice(1)}",`;
		if ($('.recipe-detail-author').length) {
			appendSrc += `"author": { "@type": "Person", "name": "${$('.recipe-detail-author').find('.vr_specialist_name').text()}" },`;
		}
		appendSrc += `"description": "${$('.vr_catch_copy').text()}",` +
			`"recipeYield": "${$('.vr_number_of_people').text()}",`;

		if ($('.recipe-detail-main-energy').length) {
			appendSrc += `"nutrition": { "calories": "${$('.vr_calorie').text()}" },`;
		}

		// 材料
		appendSrc += '"recipeIngredient": [';
		$('.recipe-detail-ingre-item').each((idx, val) => {
			appendSrc += `"${$(val).find('.recipe-detail-ingre-item-name').text()} ${$(val).find('.vridt_quantity').text()}",`;
		});
		appendSrc = appendSrc.slice(0, -1);
		appendSrc += '],';

		// Howto
		appendSrc += '"recipeInstructions": [';
		if ($('.recipe-detail-process-block').length) {
			appendSrc += `{ "@type": "HowToStep", "text": "（下準備）${$('.vr_preparations_rpt_explanation').text()} ${$('.vr_preparations_rpt_remarks').text()}" },`;
		}
		$('.recipe-detail-process-item').each((idx, val) => {
			appendSrc += `{ "@type": "HowToStep", "text": "（${idx + 1}）${$(val).find('p').text()}" },`;
		});
		appendSrc = appendSrc.slice(0, -1);
		appendSrc += ']}';

		$('.jsonld-script').append(appendSrc);
	};
	if (map === 'detail') {
		// 材料表示調整
		if ($('.recipe-detail-ingre-head1').next('.recipe-detail-ingre-body').find('.recipe-detail-ingre-head2').length) {
			$('.recipe-detail-ingre-head1').next('.recipe-detail-ingre-body').find('.recipe-detail-ingre-head2').addClass('mt0');
		}
		$('.recipe-detail-ingre-item').each((idx, ele) => {
			if ($(ele).find('.recipe-detail-ingre-item-name').length === 0) {
				$(ele).remove();
			}
		});

		setFavoDetail();
		setShare();
		setRecommendRecipe();
		setJsonld();
	}

	// [お気に入り一覧] お気に入り表示
	const setFavoList = () => {
		// localStorageから抽出
		let favoriteStorage = [];
		for (let i in localStorage) {
			if (i.indexOf('thermosFavoriteRecipeList-') !== -1) {
				favoriteStorage.push(i);
			}
		}
		if (favoriteStorage.length) {
			let jsonURL = '/ajax/favorite_recipe/list.json?';
			favoriteStorage.forEach(ele => {
				jsonURL += `recipe_id=${ele.replace(/thermosFavoriteRecipeList-/, '')}&`;
			});
			jsonURL = jsonURL.slice(0, -1);

			fetch(jsonURL).then(response => response.json()).then(data => {
				if (data.favorite_recipe_list.length) {
					let favoriteList = data.favorite_recipe_list;

					// 配列に日付を追加してソート
					favoriteList.forEach(ele => {
						ele['datetime'] = `${localStorage[`thermosFavoriteRecipeList-${ele._key}`].split('/')[0]}/${('00' + localStorage[`thermosFavoriteRecipeList-${ele._key}`].split('/')[1]).slice(-2)}/` +
							`${('00' + localStorage[`thermosFavoriteRecipeList-${ele._key}`].split('/')[2].split(' ')[0]).slice(-2)} ${localStorage[`thermosFavoriteRecipeList-${ele._key}`].split(' ')[1]}`
					});
					favoriteList.sort((x, y) => {
						let xDate = x['datetime'];
						let yDate = y['datetime'];
						if (xDate > yDate) return -1;
						if (xDate < yDate) return 1;
						return 0;
					});

					favoriteList.forEach(ele => {
						let itemHTML = `<li class="recipe-list-item">` +
							`<a href="/recipe/detail/${ele._key}.html"><figure class="recipe-list-item-img">` +
							`<img src="${ele.vr_image.src}" class="" alt=""></figure></a>` +
							`<div class="recipe-list-item-txt"><a href="/recipe/detail/${ele._key}.html"><p class="recipe-list-item-name">${ele.r_name}</p>`;
						if (ele.r_category._key === 'foodcontainer' && ele.vr_catch_copy_remarks) {
							itemHTML += `<p class="recipe-list-item-note">${ele.vr_catch_copy_remarks.content[0]}</p>`;
						}
						itemHTML +=	'</a><span class="recipe-list-item-favo"><i class="icon icon-favo"></i><i class="icon icon-favo_active is-active"></i></span>';
						$(`.recipe-favoList[data-category="${ele.r_category._key}"] ul`).append(itemHTML);
					});

					// 不要なカテゴリー枠を削除
					$('.recipe-favoList').each((idx, ele) => {
						if (!$(ele).find('li').length) { $(ele).remove(); }
					});

					// お気に入り切り替えボタンinit
					$('.recipe-list-item').each((idx, ele) => {
						let thisID = $(ele).find('a').eq(0).attr('href').split('/')[3].replace(/\.html/, '');
						let $add = $(ele).find('.icon-favo');
						let $del = $(ele).find('.icon-favo_active');
						$add.on('click', () => {
							let favoDatetime = new Date();
							favoDatetime = `${favoDatetime.getFullYear()}/${('0' + (favoDatetime.getMonth() + 1)).slice(-2)}/${(('0' + (favoDatetime.getDate())).slice(-2))} ` +
								`${('0' + (favoDatetime.getHours())).slice(-2)}:${('0' + (favoDatetime.getMinutes())).slice(-2)}:${('0' + (favoDatetime.getSeconds())).slice(-2)}`;
							localStorage.setItem('thermosFavoriteRecipeList-' + thisID, favoDatetime);
							$add.removeClass(a);
							$del.addClass(a);
							setFavoCount();
						});
						$del.on('click', () => {
							localStorage.removeItem('thermosFavoriteRecipeList-' + thisID);
							$del.removeClass(a);
							$add.addClass(a);
							setFavoCount();
						});
					});

				} else {
					$('.recipe-favoList').each((idx, ele) => { $(ele).remove(); })
					$('.js-favorite_none').removeClass('di_none');
				}
			});
		} else {
			$('.recipe-favoList').each((idx, ele) => { $(ele).remove(); })
			$('.js-favorite_none').removeClass('di_none');
		}
	};
	if (map === 'favorite.html') {
		setFavoList();
	}


})(window.jQuery, window.THERMOS, window.cssua);
